import React, { useCallback } from "react";
import { Flex, Form, Input, message, Typography } from "antd";
import { UserOutlined, LockOutlined } from "@ant-design/icons";
import { SubmitButton } from "@/components/button/submit-button";
import {
  LoginResponseSchema,
  IPVerifiedSchema,
  LoginSchema,
  AuthenSchema,
} from "@/schemas";
import { publicRequest } from "@/services";
import { useNavigate } from "react-router-dom";
import { internalIpV4 } from "internal-ip";

const onRequestLogin = async (body: LoginSchema) => {
  try {
    const result = await publicRequest<LoginSchema, LoginResponseSchema>({
      url: "/login",
      method: "POST",
      data: body,
    });

    return result.data;
  } catch (error) {
    console.log(error);
  }
};

const onRequestAuthen = async (body: AuthenSchema) => {
  try {
    const result = await publicRequest<AuthenSchema, LoginResponseSchema>({
      url: "/authen",
      method: "POST",
      data: body,
    });
    console.log(result)
    return result;
  } catch (error) {
    throw error;
  }
};

const onRequestSendIP = async (body: IPVerifiedSchema) => {
  try {
    const result = await publicRequest<IPVerifiedSchema, LoginResponseSchema>({
      url: "/ip-register",
      method: "POST",
      data: body,
    });

    console.log(result);
    return result;
  } catch (error) {
    console.log(error);
  }
};

const RegisterIPAddr: React.FC = () => {
  const [form] = Form.useForm();
  const navigate = useNavigate();

  const onFinish = () => {
    message.success("Submit success!");
  };

  const onFinishFailed = () => {
    message.error("Submit failed!");
  };

  const onLogin = useCallback(() => {
    form
      .validateFields()
      .then(async () => {
        try {
          const bodyLogin = {
            email: form.getFieldValue("email"),
            password: form.getFieldValue("password"),
          };

          const resultLogin = await onRequestLogin(bodyLogin);
          if (resultLogin?.token) {
            console.log("resultLogin");
            console.log(resultLogin);
            const bodyAuthen = {
              access_token: resultLogin?.token,
            };
            const resultAuthen: any = await onRequestAuthen(bodyAuthen);
            if (resultAuthen.code == 200) {
              console.log("resultAuthen");
              console.log(resultAuthen);
              var ip = await internalIpV4();
              const bodyIP = {
                email: bodyLogin.email,
                ip: ip ?? "",
                mac: "",
              };
              const resultIP: any = await onRequestSendIP(bodyIP);
              if (resultIP.code == 200) {
                console.log("resultIP");
                console.log(resultIP);
                message.success("Register successfully!");
                navigate('/', { replace: true });
              }
            }
          } else {
            message.error("ログインに失敗しました。 もう一度お試しください。");
          }
        } catch (error) { }
      })
      .catch(() => {
        onFinishFailed();
      });
  }, [form, navigate]);

  return (
    <Flex gap="middle" align="center" vertical>
      <Typography.Text style={{ fontSize: 24, color: "#40C1A2" }}>
        管理機能
      </Typography.Text>

      <Typography.Text style={{ fontSize: 24 }}>ログイン</Typography.Text>
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
      >
        <Form.Item
          name="email"
          label="メールアドレス"
          rules={[
            { required: true, message: "メールアドレスを再入力してください" },
            { type: "email", message: "メールは無効です。" },
          ]}
        >
          <Input
            style={{ width: 360 }}
            size="large"
            type="email"
            placeholder="メールアドレスを入力してください。!"
            prefix={<UserOutlined />}
          />
        </Form.Item>

        <Form.Item
          name="password"
          label="パスワード"
          rules={[
            { required: true, message: "パスワードを再入力してください。" },
            {
              type: "string",
              min: 8,
              message: "パスワードは8文字以上でなければなりません",
            },
          ]}
        >
          <Input
            style={{ width: 360 }}
            size="large"
            type="password"
            placeholder="パスワードを入力してください。"
            prefix={<LockOutlined />}
          />
        </Form.Item>
      </Form>
      <Form.Item>
        <SubmitButton
          onClick={onLogin}
          styles={{ width: 360 }}
          form={form}
          title={"ログイン"}
        />
      </Form.Item>
    </Flex>
  );
};

export default RegisterIPAddr;
